import { Field } from "../Layout/Field";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type ScorecardAssertValidType = "object" | "number" | "sql";

interface AssertValidFieldProps {
  assertValidType: ScorecardAssertValidType;
  onAssertValidTypeChange: (type: ScorecardAssertValidType) => void;
}

export const AssertValidField = ({
  assertValidType,
  onAssertValidTypeChange,
}: AssertValidFieldProps) => (
  <Field label="Valid format">
    <Select
      value={assertValidType}
      onValueChange={value => onAssertValidTypeChange(value as ScorecardAssertValidType)}
    >
      <SelectTrigger>
        <SelectValue placeholder="Select format" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="object">JSON object</SelectItem>
        <SelectItem value="number">Number</SelectItem>
        <SelectItem value="sql">SQL</SelectItem>
      </SelectContent>
    </Select>
  </Field>
);
